import gqlmin from 'gqlmin';
import { PageContentQuery } from './generators/PageContentQuery';

export const HomepageContentQuery = (url: string) => gqlmin(PageContentQuery(url));
